<app-mng-header></app-mng-header>
<!-- CUERPO -->
<div class="container-fluid cuerpoPrincipal">
    <router-outlet></router-outlet>
</div>
<!-- CUERPO -->
<app-mng-footer></app-mng-footer>






// WEBPACK FOOTER //
// ./src/app/app-manager/manager.component.html